import { chevron_right_gray400 } from '@assets/icons';
import { Frame, ImageListItemComponent, ImageModal, MenuTop, Text } from '@components';
import { PathnameEnum } from '@constant';
import { useUsedImageList } from '@hooks';
import { colorSet } from '@theme';
import { IImageListItem } from '@types';

const UsedImageListPage = () => {
  const {
    handleBreadCrumbClick,
    data,
    flattenUsedImageList,
    outputBottomRef,
    isImageModalVisible,
    imageModalType,
    selectedImageInfo,
    sequenceInfo,
    handleImageClick,
    handleImageModalClose,
    handleImageUseButtonClick
  } = useUsedImageList();

  const horizontalGap = 15;
  const itemNumberPerRow = 7;
  const sumOfHorizontalGaps = horizontalGap * (itemNumberPerRow - 1);
  const itemSize = `calc((100% - ${sumOfHorizontalGaps}px) / ${itemNumberPerRow})`;

  return (
    <>
      <MenuTop />

      <Frame width="100%" padding="48px 40px 96px 40px">
        <div>
          <div
            onClick={handleBreadCrumbClick}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: '4px',
              cursor: 'pointer'
            }}
          >
            <Text variant="body1" color="primary" marginRight="10px">
              컬렉션
            </Text>
            <img src={chevron_right_gray400} style={{ width: 16, height: 16 }} />
          </div>
          <Text variant="h2" fontWeight="bold" marginBottom="80px">
            사용한 이미지
          </Text>
        </div>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: `15px ${horizontalGap}px`,
            width: '100%',
            boxSizing: 'border-box'
          }}
        >
          {data &&
            flattenUsedImageList().length > 0 &&
            flattenUsedImageList().map((item: IImageListItem) => {
              return (
                <ImageListItemComponent
                  key={item.id}
                  item={item}
                  itemSize={itemSize}
                  onImageClick={handleImageClick}
                  onUseButtonClick={handleImageUseButtonClick}
                />
              );
            })}
        </div>
        <div ref={outputBottomRef} />

        {(!data || flattenUsedImageList().length === 0) && (
          <div
            style={{
              height: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Text variant="body1" color={colorSet.gray500}>
              저장한 이미지가 없습니다.
            </Text>
          </div>
        )}
      </Frame>

      <ImageModal
        isVisible={isImageModalVisible}
        onClose={handleImageModalClose}
        initialImageModalType={imageModalType}
        initialSelectedImageInfo={selectedImageInfo}
        initialSequenceInfo={sequenceInfo}
        onUseButtonClick={handleImageUseButtonClick}
      />
    </>
  );
};

export default UsedImageListPage;
